export class MastrPvUnitDto {
  public mastrNummer: string;
  public installierteLeistung: number;
  public anzahlModule: number;
  public nettoLeistung: number;
  public leistungsbegrenzung: unknown;
  public registrierungsdatum: string | Date;
  public zugeordneteWirkleistungWechselrichter: number;
  public einspeisungsart: string;
  public inbetriebnahmedatum: string | Date;
  public energietraeger: string;
  public bruttoleistung: number;
  public lage: string;
  public einheitlicheAusrichtungUndNeigungswinkel: boolean;
  public hauptausrichtung: string;
  public hauptausrichtungNeigungswinkel: string;
  public nebenausrichtung: string;
  public nebenausrichtungNeigungswinkel: string;
  public nutzungsbereich: string;
  public eegMastrNummer: string;
  public speicherAmGleichenOrt: boolean;
  public lokationMastrNummer: string;
}

export class MastrStorageUnitDto {
  public mastrNummer: string;
  public einsatzort: string;
  public acDcKoppelung: string;
  public batterietechnologie: string;
  public nutzbareSpeicherkapazitaet: number;
  public speMastrNummer: string;
  public eegMastrNummer: string;
  public eegAnlagentyp: string;
  public technologie: string;
  public reserveartNachDemEnWG: string;
  public gemeinsamRegistrierteSolareinheitMastrNummer: string;
  public lokationMastrNummer: string;
}

export class MastrLocationDto {
  public mastrNummer: string;
  public netzbetreiberpruefungStatus: string;
  public postleitzahl: string;
  public strasse: string;
  public strasseNichtGefunden: boolean;
  public hausnummerWert: string;
  public hausnummerNichtVorhanden: boolean;
  public hausnummerNichtGefunden: boolean;
  public ort: string;
  public pvUnits: MastrPvUnitDto[];
  public storageUnits: MastrStorageUnitDto[];
}

export class MastrMarketActor {
  firstName: string;
  lastName: string;
  zipCode: string;
  street: string;
  streetAddition: string;
  streetNumber: string;
  city: string;
}

export class MastrPvPlantWithLocationDto {
  public pvUnit: MastrPvUnitDto;
  public location: MastrLocationDto;
  public marketActor: MastrMarketActor;
}

// Legacy DTO for backward compatibility - maps to the main PV unit
export class MastrDataDto {
  public get installedPower(): number {
    return this.pvPlant?.pvUnit?.installierteLeistung;
  }
  public get numberOfModules(): number {
    return this.pvPlant?.pvUnit?.anzahlModule;
  }
  public get netPower(): number {
    return this.pvPlant?.pvUnit?.nettoLeistung;
  }
  public get limiting(): unknown {
    return this.pvPlant?.pvUnit?.leistungsbegrenzung;
  }
  public get registerDate(): string | Date {
    return this.pvPlant?.pvUnit?.registrierungsdatum;
  }
  public get production(): number {
    return this.pvPlant?.pvUnit?.zugeordneteWirkleistungWechselrichter;
  }
  public get feedInType(): string {
    return this.pvPlant?.pvUnit?.einspeisungsart;
  }

  public get marketActor(): MastrMarketActor {
    return this.pvPlant.marketActor;
  }

  public get location(): MastrLocationDto {
    return this.pvPlant.location;
  }

  constructor(public pvPlant: MastrPvPlantWithLocationDto) {}
}
